import { isMobile } from 'react-device-detect';

export const useViewMode = () => {
  return isMobile ? 'mobile' : 'desktop';
};
